<script setup>
const checked = defineModel()

const props = defineProps({
  value: null,
  classOverrides: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  labelClass: {
    type: String,
    default: ''
  },
  name: {
    type: String
  },
  size: {
    type: String,
    default: 'small'
  }
})

defineOptions({
  inheritAttrs: false
})

const inputId = `t-radio-${Math.random().toString(36).slice(2, 11)}`
const checkedClass = computed(() => (checked.value === props.value ? 'checked' : ''))
</script>

<template>
  <div
    class="d-flex align-items-baseline"
    :class="[classOverrides, checkedClass]"
  >
    <p-radio-button
      v-model="checked"
      :name
      :value
      :size
      :input-id
      :disabled
      style="margin-right: 0.4rem"
    />
    <label
      :for="inputId"
      :class="labelClass"
    >
      <slot></slot>
    </label>
  </div>
</template>

<style scoped>
.p-disabled + label {
  color: var(--p-surface-300);
}
</style>
